/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ h: NonNullable<unknown>, m: NonNullable<unknown> }} Dur_H_MInputs */

const en_dur_h_m = /** @type {(inputs: Dur_H_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.h}h ${i?.m}m`)
};

const he_dur_h_m = /** @type {(inputs: Dur_H_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.h}ש׳ ${i?.m}ד׳`)
};

/**
* | output |
* | --- |
* | "{h}h {m}m" |
*
* @param {Dur_H_MInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const dur_h_m = /** @type {((inputs: Dur_H_MInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dur_H_MInputs, { locale?: "en" | "he" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dur_h_m(inputs)
	return he_dur_h_m(inputs)
});